const useEnv = () => {
  return window.__RUNTIME_CONFIG__;
};

export default useEnv;
